<template>
    <v-row v-if="hasLinks">
        <v-col cols="12" class="title-section pb-0">
            {{ $t('common.video_to_see') }}
        </v-col>
        <v-col cols="12">
            <div class="card-container">
                <loading-spinner height="140px" v-if="loading"/>
                <v-carousel v-else v-model="carousel" hide-delimiters :cycle="false" height="100%" :show-arrows="links.length > 1">
                    <v-carousel-item v-for="(link, i) in links" :key="i">
                        <div class="pa-3">
                            <youtube-iframe :link="link" height="200"/>
                        </div>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {db} from "@/utils/Firebase";
import YoutubeIframe from "@/components/common/YoutubeIframe";
export default {
    name: "StudentYoutubeVideos",
    components: {YoutubeIframe, LoadingSpinner},
    props: {
        coachId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            carousel: 0,
            links: null
        }
    },
    computed: {
        hasLinks(vm = this) {
            return vm.links && vm.links.length > 0
        }
    },
    async mounted() {
        const vm = this
        await vm.loadLinks()
    },
    methods: {
        async loadLinks() {
            const vm = this
            vm.loading = true
            let coach = await db.collection('users').doc(vm.coachId).get()
            if(coach.data()?.links && coach.data()?.links?.length > 0) vm.links = coach.data().links
            vm.loading = false
        }
    },
    watch: {
        hasLinks(val) {
            this.$emit('show', val)
        }
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
}

</style>